import { GetUsersVtResItem } from '~hooks/queries/users/use-get-users-vt'

export const mockUsers: GetUsersVtResItem[] = [
  {
    sub: '123',
    email: 'bob@test.dk',
    name: 'Bob',
    poolpartners: [
      {
        name: 'CST',
        poolPartnerKey: 'CST',
        partnerId: '234',
      },
      {
        name: 'Cido Shipping',
        poolPartnerKey: 'CID',
        partnerId: '345',
      },
    ],
    roles: [
      {
        _id: '456',
        sub: '123',
        entity: 'poolpartner',
        id: 'CST',
        role: 'user',
        roleDisplayName: 'User',
        name: 'CST',
        poolPartnerKey: 'CST',
        partnerId: '234',
      },
      {
        _id: '567',
        sub: '123',
        entity: 'poolpartner',
        id: 'CID',
        role: 'user',
        roleDisplayName: 'User',
        name: 'Cido Shipping',
        poolPartnerKey: 'CID',
        partnerId: '345',
      },
    ],
  },
  {
    sub: 'abc',
    email: 'jog@maersktankers.com',
    name: 'Johann',
    poolpartners: [],
    roles: [
      {
        _id: 'bcd123',
        sub: 'abc',
        entity: 'vessel',
        id: 'cde123',
        role: 'mtops',
        roleDisplayName: 'MT Ops',
        vesselName: 'Asp Sunrise',
        imoNumber: '9713014',
        pool: 'Chemicals 2',
        poolPartner: 'ASP',
        vesselId: 'cde123',
        poolPartnerKey: 'ASP',
      },
      {
        _id: '123abc',
        sub: 'abc',
        entity: 'vessel',
        id: '223aab',
        role: 'mtops',
        roleDisplayName: 'MT Ops',
        poolPartner: 'CID',
        pool: 'MR',
        imoNumber: '9332169',
        vesselName: 'Atlantic Crown',
        vesselId: '223aab',
        poolPartnerKey: 'CID',
      },
    ],
  },
]
